const CART = "CART";
const BASKET = "BASKET_V3";

const shoppingType = {
  CART,
  BASKET,
};

export default shoppingType;
